<template>
   <div class="rolePermissions">
      <el-dialog title="友情提示" :visible.sync="dialogVisible1" :width="screenWidth>768?'30%':'80%'" :before-close="sure" center>
         <div style="text-align:center;font-size:16px;"><span>{{!userRole?'报名前请登录'+roleName1+'账号':'当前为'+userRoleName()+'账户，请用'+roleName+'账户登录系统'}}</span></div>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sure">确 定</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
   props: {
      roleName: String,
      dialogVisible:Boolean
   },
   data() {
      return {
         roleName1:"",
         dialogVisible1:false
      };
   },
   watch:{
      dialogVisible(){
         this.roleName1 = this.roleName
         this.dialogVisible1 = this.dialogVisible
      }
   },
   computed: {
      ...mapGetters(["userRole","screenWidth"]),
      userRoleName() {
        return function() {
          return this.userRole==1?'运动员':this.userRole==2?'考评员':this.userRole==3?'测试机构':''
        }
      }
   },
   methods: {
      sure(){
         this.dialogVisible1 = !this.dialogVisible1
         this.$emit('changeDialogVisible', this.dialogVisible1)
      }
   }
};
</script>

<style lang="less" scoped>
</style>
